export const pt_pt = {
    "TRIGGER_LISTEN": "A ouvir os gatilhos",
    "ASSIST_EMPTY_MSG": "O Agente AI está a ouvir ativamente a sua conversa e pronto para ajudar automaticamente quando acionado.",
    "MYBOT_TRIGGET_LISTEN": "Nenhuma tarefa ativa do Meu Bot atualmente",
    "MYBOT_EMTPY_MSG": "Para iniciar uma tarefa no Meu Bot, vá até à aba de pesquisa e selecione a opção \"Executar com entradas do agente\" para a tarefa desejada.",
    "PROACTIVE_MODE": "Modo Proativo",
    "SETTINGS": "Definições",
    "HELP_AND_SUPPORT": "Ajuda e Suporte",
    "HELP": "Ajuda",
    "LANGUAGE": "Idioma",
    "THEME": "Tema",
    "AUTOMATIC": "Automático",
    "DARK": "Escuro",
    "LIGHT": "Claro",
    "THEME_DESC": "Isto usará o modo padrão do seu sistema",
    "DOCUMENTATION": "Documentação",
    "DOC_DESC": "Consulte os nossos artigos de documentação detalhados.",
    "FAQ_U": "FAQ",
    "FAQ_DESC": "Consulte as perguntas frequentes sobre o Agente AI.",
    "KORE_ACADEMY": "Kore Academy",
    "KORE_ACA_DESC": "Aprenda mais sobre o Agente AI através dos cursos da academia.",
    "SEARCH": "Pesquisar",
    "MY_BOT": "Meu Bot",
    "FILE_NAME":"Nome do ficheiro",
    "ASSIST": "Assistir",
    "AUTO_SCROLL_TOOLTIP":"Controla a rolagem automática da guia Assistência, Meu bot e conteúdos da guia Transcrição",
    "TRANSCRIPT": "Transcrição",
    "HISTORY": "História",
    "STARTOVER": "Recomeçar",
    "RESTART_INPUTS": "Recomeçar com entradas capturadas",
    "ASKCUSTOMER": "Perguntar ao Cliente",
    "TELLCUSTOMER": "Dizer ao Cliente",
    "WELCOME_MSG": "Mensagem de Boas-Vindas",
    "TAB_TEXT":"Nenhuma aba ativada! Ative pelo menos uma aba",
    "SEND": "Enviar",
    "SENT": "Enviado",
    "AWAITING": "Aguardando Resposta  |  Digite para continuar",
    "OVERRIDE": "Digite para continuar",
    "OVERRIDE_FILE": "Anexar arquivo para continuar",
    "ACCEPT_RESPONSE": "Resposta Aceita",
    "AGENT_ENTERED": "Agente Entrou",
    "EXPECTED_FORMAT": "Formato Esperado",
    "TAP_SEARCH":"Toque para pesquisar",
    "INPUT_VALUES": "Valores de Entrada",
    "RESTART": "Recomeçar",
    "START_OVER": "Recomeçar",
    "RESTART_CAPTURE": "Recomeçar com entradas capturadas",
    "CANCEL": "Cancelar",
    "INTERRUPT_DIALOG": "TAREFA DE DIÁLOGO INTERROMPIDO",
    "RUN": "EXECUTAR",
    "RUN_AGENT": "Executar com entradas do agente",
    "STEP": "Passo",
    "DIALOG_TASK": "Tarefa de Diálogo",
    "FAQ": "FAQ",
    "SNIPPET": "Respostas",
    "ARTICLE": "Páginas Web",
    "FILE": "Arquivos",
    "SUGGESTED": "Sugerido",
    "ALL_DIALOG": "Todas as Tarefas de Diálogo",
    "DIALOG_TEXT": "Diálogo",
    "INTENT_IDENTIFIED": "Fala do cliente",
    "NOT_WHAT_LOOKING": "Sugestão Errada?",
    "BOT": "Bot",
    "CUSTOMER": "Cliente",
    "YOU": "Você",
    "TERMINATE_CONV": "Terminar Tarefa de Diálogo",
    "TERMINATE_CONV_DESC": "Tem certeza de que deseja terminar a tarefa de diálogo? O Agente AI não poderá mais fazer sugestões.",
    "YES_TERMINATE": "Sim, Terminar",
    "NO_CANCEL": "Não, Cancelar",
    "OVERRIDE_CONTINUE": "Continuar com modo de sobreposição",
    "SUMMARY_TEXT": "Resumo",
    "SUBMIT": "Submeter",
    "INTERRUPT_OCCURED": "Interrupção Ocorreu",
    "IDENTIFIED_INTENT": "Intenção Identificada",
    "INTERRUPT_DESC": "Executar isto terminará a sua Tarefa de Diálogo em andamento.",
    "ACCEPT_RUN": "Aceitar e Executar",
    "RUN_LATER": "Executar Mais Tarde",
    "KNOW_MORE": "Saber Mais",
    "MORE_TEXT": "Mais",
    "LESS_TEXT": "Menos",
    "VIEW_MORE": "Ver Mais",
    "VIEW_LESS": "Ver Menos",
    "SHOW_MORE_FAQ": "Mostrar mais FAQs",
    "SHOW_LESS_FAQ": "Mostrar menos FAQs",
    "SHOW_MORE_ARTICLE": "Mostrar mais páginas web",
    "SHOW_LESS_ARTICLE": "Mostrar menos páginas web",
    "SHOW_MORE_SNIPPET": "Mostrar mais Respostas",
    "SHOW_LESS_SNIPPET": "Mostrar menos Respostas",
    "SHOW_MORE_FILES": "Mostrar Mais Arquivos",
    "SHOW_LESS_FILES": "Mostrar Menos Arquivos",
    "VIEW_ALL_DIALOG": "Ver todos os Diálogos",
    "VIEW_FEW_DIALOG": "Ver poucos Diálogos",
    "HELP_FULL": "Útil?",
    "THANKYOU": "Obrigado!",
    "EXPAND_MORE": "Expandir / Mais",
    "CLOSE_TEXT": "Fechar",
    "STARTED": "Iniciado",
    "ENDED": "terminado",
    "VIEW_FULL_ARTICLE": "Ver página web",
    "VIEW_FULL_FILE": "Ver arquivo",
    "COPIED": "Copiado",
    "SENTI_ANALY": "Análise de Sentimento",
    "WRONG_SUGGESTION": "Sugestão Errada",
    "INCORRECT_INTENT": "Intenção Incorreta",
    "ACCIDENTAL_CLICK": "Clique Acidental",
    "TIME_TAKING": "Demora muito tempo",
    "OTHER": "Outro",
    "PLAYBOOK_EMPTY_MSG": "Selecionar Playbook",
    "PLAYBOOK_EMPTY_DESC": "O Agente AI não consegue carregar o playbook devido a todos os playbooks disponíveis serem dinâmicos. Clique em 'Selecionar Playbook' para aceder ao playbook.",
    "STAGE": "Estágio",
    "PROCEED_TO_CLOSE": "Prosseguir para fechar",
    "RECOMENDED_PLAYBOOK": "PLAYBOOK RECOMENDADO",
    "PRIMARY_SCRIPTS": "SCRIPTS PRINCIPAIS",
    "DYNAMIC_SCRIPTS": "SCRIPTS DINÂMICOS",
    "RESUME": "Retomar",
    "ENABLE_CLOSE": "Clique no botão prosseguir para fechar para ativar o Estágio de Fecho",
    "LIST_VIEW": "Vista de Lista",
    "TERMINATE": "Terminar",
    "MINIMIZE": "Minimizar",
    "MAXIMIZE": "Maximizar",
    "NO_SEARCH_RESULT": "Nenhum resultado de pesquisa encontrado",
    "SENTIMENT_AWAITING": "Aguardando por sentimento",
    "POSITIVE": "Positivo",
    "NEGATIVE": "Negativo",
    "ASSOCIATED_WORK_NOTES": "Notas de Resolução Passadas",
    "AGENT_JOINED_CONV": "Agente juntou-se à conversa",
    "AUTOSCROLL_ASSIST": "Assistência de Auto-Rolagem do Conteúdo da Aba",
    "FILE_SIZE_MSG": "O tamanho do arquivo deve estar dentro de 25MB. Por favor, tente novamente.",
    "OVERRIDE_BTN": "Sobrescrever",
    "CHOOSE_FILE": "Escolher Arquivo",
    "SUMMARY_ERROR_TEXT": "Desculpe, mas houve um problema ao gerar o resumo para esta conversa. Por favor, crie o seu próprio resumo.",
    "ASK_A_QUESTION": "Fazer uma pergunta",
    "COPY": "Copiar",
    "TELL_US_MORE": "Conte-nos mais...",
    "THANKS_FEEDBACK": "Obrigado pelo seu feedback",
    "SOMETHING_WRONG": "Algo correu mal",
    "CLICK_ERROR_DETAILS": "Clique para ver os detalhes do erro",
    "NO_ACTIVE_PLAYBOOK": "Sem playbook ativo",
    "REPHRASE_QUESTION": "Pode reformular a sua pergunta ou perguntar outra coisa?",
    "INTERNAL_INFO": "Informação interna",
    "SOURCES": "Fontes",
    "CONVERSATION_SUMMARY": "Resumo da conversa",
    "WAITING": "À espera",
    "PLAYBOOK": "Playbook",
    "WIDGET_DISABLED": "Widget desativado",
    "AI_SETTINGS_DISABLED": "Configurações de IA desativadas! Entre em contato com o administrador de IA",
    "SERVER_CONNECTION_ERROR": "Erro ao conectar-se ao servidor",
    "VIEW": "Ver",
    "ATTACHMENT_INPUT": "Entrada de anexo",
    "TYPE_SUMMARY": "Digite o resumo",
    "VIEW_FULL_ARTICLE_2": "Ver o artigo completo",
    "VIEW_FULL_FILE_2": "Ver o ficheiro completo",
    "BY":"Por",
    GENERATE_SUMMARY: "Gerar sumário",
    PREV_SUMMARIES: "Sumários gerados anteriormente",
    DIALOG_WORKFLOWS: "Fluxos de trabalho de diálogo",
    SHOW_ALL_DIALOG: "Mostrar todas as tarefas de diálogo",
    SHOW_ALL_DIALOGS: "Mostrar todos os diálogos",
    CUSTOM_TAB: "Separador personalizado",
    AGENT_INPUT: "Entrada do agente",
    CUSTOM_EMPTY_MSG: "Nenhum fluxo de trabalho ativo",
    CUSTOM_TAB_DESC: "Para iniciar um fluxo de trabalho, execute um dos itens da lista presente na parte inferior da tela.",
    SUBMIT_OVERALL_FEEDBACK: "Enviar feedback geral",
    FEEDBACK_POPUP_SUBTITLE: "Feedback sobre o widget e suas funcionalidades",
    FEEDBACK_SATISFIED: "Satisfeito",
    FEEDBACK_UNSATISFIED: "Insatisfeito",
    FEEDBACK_PROVIDE_REASONS: "Fornecer razões",
    FEEDBACK_TITLE: "Feedback",
    "AGENTIC_THINKING" : "A pensar",
    "AGENTIC_AGENT_TITLE" : "Agente",
    "AGENTIC_COPILOT_MODE_TITLE" : "Modo Copiloto Agente",
    "AGENTIC_SENDING_MESSAGE" : "A enviar...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot está a ouvir ativamente a sua conversa e pronto para assistir automaticamente",
    "AGENTIC_SEARCH_RESULTS" : "Resultados Agentes"
}
